import { Card, Flex, Text, Title, CardProps, Badge } from '@mantine/core'
import accounting from 'accounting'
import React from 'react'
interface IStat extends Omit<CardProps, 'children'> {
  label?: string
  isMoney?: boolean
  unit?: string
  diff?: string | number | null
  value: string | number
  precision?: number
}
const Stat = ({ label, isMoney, unit, diff, value, precision = 2, ...others }: IStat) => {
  let stat_value = value
  const diff_number = Number(diff)
  if (isMoney) {
    stat_value = accounting.formatMoney(Number(value), {
      symbol: '',
      precision: precision,
    })
  }
  return (
    <Card radius="md" px="lg" py="xs" {...others} miw="fit-content">
      {label && <Text mb="xs">{label}</Text>}
      <Flex align="stretch" h={40}>
        <Title size="35px">{stat_value}</Title>
        {unit && (
          <Flex ml="xs" direction="column" justify="end">
            {diff && (
              <Badge py="xs" px="4px" radius="sm" variant="filled" color={diff_number > 0 ? 'teal.5' : diff_number < 0 ? 'red' : 'gray'}>
                {typeof diff === 'string' ? diff : diff_number.toFixed(2)}%
              </Badge>
            )}
            <Text size="xs" mb="3px">
              {unit}
            </Text>
          </Flex>
        )}
      </Flex>
    </Card>
  )
}

export default Stat
